<template>
  <div class="noDate">
    <template v-if="type == 1">
      <div class="empty-data">
        <img src="@/assets/img/load-boards/eld.svg" />
        <span class="no-eld-tips">Driver not associated with ELD data</span>
        <div>
          <commonButton type="primary" @click='goSetEld' size="mini">SET UP ELD</commonButton>
        </div>
      </div>
    </template>
    <template v-if="type == 2">
      <div class="empty-data">
        <img src="@/assets/img/load-boards/eld.svg" />
        <span class="no-eld-tips">ELD data is loading, check back soon</span>
      </div>
    </template>
    <template v-if="type == 3">
      <div class="empty-data">
        <img src="@/assets/img/load-boards/driver.svg" />
        <span class="no-driver-tips">No driver assigned</span>
        <el-tooltip el-tooltip :disabled="isEidt"  :content="isEidt ? '' : 'No Permission'" placement="bottom">
          <div>
            <commonButton :disabled="!isEidt" type="primary" @click="assgin" size="mini">ASSIGN</commonButton>
          </div>
        </el-tooltip>
      </div>
    </template>
    <template v-if="type == 4">
      <div class="empty-data">
        <img src="@/assets/img/load-boards/no-data-2.svg" />
        <span class="empty-title">The load is not started</span>
        <!-- <span class="empty-content">Load progress will be updated by GPS and driver’s update from Trucker Path App. </span> -->
      </div>
    </template>
    <template v-if="type == 5">
      <div class="empty-data">
        <img src="@/assets/img/load-boards/no-data-2.svg" />
        <span class="empty-title">No ELD Data</span>
        <!-- <span class="empty-content">Load progress will be updated by GPS and driver’s update from Trucker Path App. </span> -->
      </div>
    </template>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import isOwner from '@/tools/is-owner.js'
import { systemInfo } from '@/shared-services'
import { getService$ } from '@/shared-services.js'
export default {
  name: 'NoDate',
  components: {
  },
  mixins: [isOwner],
  props: {
    type: {
      type: [Number, String],
      default: 4
    },
    dsp_permission: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    ...mapState({
      loadDetailList: (state) => state.dispatch.loadDatailList,
      routeData: (state) => state.dispatch.routeData || [],
      user: (state) => state.user || [],
      eventLine: state => state.tracking.trackingInfo,
      trackingRequestLoading: state => state.tracking.trackingRequestLoading,
      usersAuthorities: (state) => state.user.usersAuthorities
    }),
    isEidt() {
      if(this.isCommand) {
        if(this.loadDetailList.loadInfo.source !== 'command') {
          return this.usersAuthorities['fleet:carrierBusiness:accessCreateByDispatcher'] === 'edit'
        }
      }else {
        return this.loadDetailList.loadInfo.source === 'command' ? false : !this.dsp_permission
      }
      return this.isOwnerFn(this.loadDetailList.loadInfo.ownerId) ? true : this.usersAuthorities['fleet:business:accessCompanyLoads'] === 'edit'
    },
    noDriverFlag() {
      return this.loadDetailList.loadInfo.driverPhone ? false : true;
    },
  },
  data() {
    return {
      isCommand: systemInfo.system == "Command",
    }
  },
  created() {
    console.log(this.loadDetailList)
  },
  methods: {
    ...mapActions({
      showChatbox: "im/showChatbox",
      showAssgin: "dispatch/showAssgin",
      getLoadTrackingAsync: 'tracking/getLoadTracking',
      getIsLoading: 'tracking/getIsLoading'
    }),
    goSetEld() {
      this.$router.push({
        path: '/setting/eld/add-integration'
      })
    },
    assgin() {
      getService$('CommandTools').subscribe(x => {
        x.$fleetShowDialog.next({showAssign: true,  data: this.loadDetailList.loadInfo, type: 'assign', pageType: 'detail'})
      })
      // console.log('93result', this.loadDetailList.loadInfo, this.loadDetailList.loadInfo.id,)
      // this.showAssgin({
      //   assginData: true,
      //   value: {
      //     loadInfo: this.loadDetailList.loadInfo,
      //     name: "Assign", 
      //     id: this.loadDetailList.loadInfo.id,
      //   },
      //   name: "Assign",
      // });
    }
  }
}
</script>
<style lang="scss" scoped>
  .noDate{
    height: 100%;
    width: 100%;
  }
  .empty-data{
    padding-top: 164px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .no-eld-tips{
    margin-top: 10px;
    margin-bottom: 24px;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: #7F8596;
  }
  .no-driver-tips{
    margin-top: 21px;
    margin-bottom: 24px;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: #7F8596;
  }
  .empty-title{
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
    color: #7F8596;
    margin-top: 21px;
    margin-bottom: 4px;
    text-align: center;
  }
  .empty-content{
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #7F8596;
    width: 250px;
    text-align: center;
  }
</style>